module.exports = __webpack_public_path__ + "6592cf8c421f8527635fcdea38dcf127.svg";